<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label='类型'>
        <Select v-model="formValidate.type" filterable>
          <Option
            v-for="item in typeList"
            :value="item.id"
            :key="item.id"
            >{{ item.value }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="客户" v-if="isEdit">
        <Input v-model="formValidate.customerName" disabled></Input>
      </FormItem>
      <FormItem label="客户" prop="customerId" v-else>
        <Select v-model="formValidate.customerId" filterable>
          <Option
            v-for="item in customerList"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="门店" v-if="isSale">
        <Input v-model="formValidate.factoryName" disabled></Input>
      </FormItem>
      <FormItem label="门店" prop="factoryId" v-else>
        <Select
          v-model="formValidate.factoryId"
          @on-change="searchSales"
          filterable
        >
          <Option v-for="item in factoryList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="预计交期" prop="arrivedTime">
        <Date-picker
          :value="formValidate.arrivedTime"
          @on-change="formValidate.arrivedTime = $event"
          type="datetime"
          placeholder="选择预计交期"
          style="width: 170px"
        ></Date-picker>
      </FormItem>
      <FormItem label="负责人" v-if="isSale">
        <Input v-model="formValidate.salesUserName" disabled></Input>
      </FormItem>
      <FormItem label="负责人" prop="salesUserId" v-else>
        <Select v-model="formValidate.salesUserId" filterable>
          <Option v-for="item in userList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="预计匹数" prop="expectPieceCount">
        <Input
          v-model="formValidate.expectPieceCount"
          placeholder="请输入预计匹数"
        ></Input>
      </FormItem>
      <FormItem label="备注">
        <Input v-model="formValidate.remarks" type="textarea" :rows="7"></Input>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],
      customerList: [],
      factoryList: [],
      userList: [],
      isSale: false,
      isEdit: false,
      typeList: [{ id: 0, value: '验布类' }, { id: 1, value: '包装类' }],

      formValidate: {
        id: '',
        customerId: '',
        customerName: '',
        factoryId: '',
        factoryName: '',
        arrivedTime: '',
        salesUserId: '',
        salesUserName: '',
        expectPieceCount: '',
        remarks: '',
        type: 0
      },
      ruleValidate: {
        customerId: [
          {
            required: true,
            message: '客户必须选择',
            trigger: 'change'
          }
        ],
        factoryId: [
          {
            required: true,
            message: '门店必须选择',
            trigger: 'change'
          }
        ],
        arrivedTime: [
          {
            required: true,
            message: '预计交付时间不能为空',
            trigger: 'change'
          }
        ],
        expectPieceCount: [
          {
            required: true,
            message: '预计匹数不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            pattern: /^\d+$/,
            message: '请输入数字',
            trigger: 'blur'
          }
        ],
        salesUserId: [
          {
            required: true,
            message: '负责人必须选择',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setIsSale (flag) {
      this.isSale = flag
    },
    setIsEdit (flag) {
      this.isEdit = flag
    },
    setSaleData (sale) {
      this.formValidate.factoryId = sale.factory_id
      this.formValidate.factoryName = sale.factory_name
      this.formValidate.salesUserId = sale.id
      this.formValidate.salesUserName = sale.real_name
    },
    setCustomerData (customerList) {
      var data = new Array()
      for (var i = 0; i < customerList.length; i++) {
        data[i] = {
          id: customerList[i].id.toString(),
          name: customerList[i].name
        }
      }
      this.customerList = data
    },
    setFactoryData (factoryList) {
      var data = new Array()
      for (var i = 0; i < factoryList.length; i++) {
        data[i] = {
          id: factoryList[i].id.toString(),
          name: factoryList[i].name
        }
      }
      this.factoryList = data
    },
    setUserData (userList) {
      var data = new Array()
      for (var i = 0; i < userList.length; i++) {
        data[i] = {
          id: userList[i].id.toString(),
          name: userList[i].real_name
        }
      }
      this.userList = data
    },

    setData (permissionList) {
      var data = new Array()
      for (var i = 0; i < permissionList.length; i++) {
        data[i] = { key: permissionList[i].id, label: permissionList[i].name }
      }
      this.data = data
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.type = data.type
      this.formValidate.customerId = data.customer_id.toString()
      this.formValidate.customerName = data.customerName
      this.formValidate.factoryId = data.factory_id.toString()
      this.formValidate.arrivedTime = data.arrived_time.toString()
      this.formValidate.salesUserId = data.sales_user_id.toString()
      this.formValidate.expectPieceCount = data.expect_piece_count.toString()
      this.formValidate.remarks = data.remarks
    },

    searchSales () {
      this.$emit('searchSales', this.formValidate.factoryId)
    },

    handleChange (newTargetKeys) {
      this.formValidate.permissions = newTargetKeys
    },
    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
